export default __webpack_public_path__ + "static/media/arrowPrev.a563e09d.svg";